import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1 lg:col-span-1">
            <h3 className="font-heading text-2xl text-white mb-2">
              Destilerija <span className="gold-text">Kovačić</span>
            </h3>
            <p className="text-white/40 text-sm">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-white/80 mb-6">
              {t('footer_links')}
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-white/40 hover:text-gold transition-colors text-sm">
                {t('nav_home')}
              </Link>
              <Link to="/shop" className="text-white/40 hover:text-gold transition-colors text-sm">
                {t('nav_shop')}
              </Link>
              <Link to="/about" className="text-white/40 hover:text-gold transition-colors text-sm">
                {t('nav_about')}
              </Link>
              <Link to="/rent-gin-bar" className="text-white/40 hover:text-gold transition-colors text-sm">
                {language === 'sr' ? 'Rentiraj Džin Bar' : 'Rent Gin Bar'}
              </Link>
              <Link to="/contact" className="text-white/40 hover:text-gold transition-colors text-sm">
                {t('nav_contact')}
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-white/80 mb-6">
              {t('footer_contact')}
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:+381604631241"
                className="flex items-center gap-3 text-white/40 hover:text-gold transition-colors text-sm"
              >
                <Phone size={14} strokeWidth={1.5} />
                +381 60 463 1241
              </a>
              <a
                href="mailto:destilerijakovacic@gmail.com"
                className="flex items-center gap-3 text-white/40 hover:text-gold transition-colors text-sm break-all"
              >
                <Mail size={14} strokeWidth={1.5} className="flex-shrink-0" />
                <span className="break-all">destilerijakovacic@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-white/40 text-sm">
                <MapPin size={14} strokeWidth={1.5} className="flex-shrink-0" />
                {t('contact_location')}
              </div>
            </div>
          </div>

          {/* Age Notice */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase text-white/80 mb-6">
              {t('footer_follow')}
            </h4>
            <div className="flex gap-4 mb-4">
              <a
                href="https://www.instagram.com/destilerija.kovacic/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/40 hover:text-gold hover:border-gold/50 transition-all"
                data-testid="footer-instagram-2"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/destilerija.kovacic"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/40 hover:text-gold hover:border-gold/50 transition-all"
                data-testid="footer-facebook-2"
              >
                <Facebook size={18} strokeWidth={1.5} />
              </a>
            </div>
            <p className="text-white/30 text-sm leading-relaxed">
              {t('footer_age_notice')}
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            © {currentYear} Destilerija Kovačić. {t('footer_rights')}
          </p>
          <p className="text-white/30 text-xs">
            Mokrin, Srbija
          </p>
        </div>
      </div>
    </footer>
  );
}
